import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'ord-admin-cancel-process',
  imports: [MatDialogModule, MatButtonModule, TranslateModule, MatIcon],
  templateUrl: './cancel-process.component.html',
  styleUrl: './cancel-process.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CancelProcessComponent {
  private readonly dialogRef = inject(MatDialogRef<CancelProcessComponent>);


  public onSave(): void {
    this.dialogRef.close(true);
  }
}
